export default __webpack_public_path__ + "static/media/Alcohol-HEAD.4b443454.png";